"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _contexts = require("../contexts");
var _siteActions = require("./site-actions");
const MEMBER_GRACE_PERIOD = 30; // in days
// returns settings according to current intrusiveness level

function useIntrusiveness() {
  const {
    intrusivenessLevels
  } = (0, _react.useContext)(_contexts.Settings);
  const {
    totalContents,
    memberValidation
  } = (0, _react.useContext)(_contexts.Storage);
  const isValidatedMember = useValidation(memberValidation);
  const currentSettings = (0, _react.useMemo)(() => {
    if (isValidatedMember) return intrusivenessLevels[0];
    return intrusivenessLevels.sort((a, b) => a.contentThreshold - b.contentThreshold).reduce((acc, curr) => {
      return totalContents >= curr.contentThreshold ? curr : acc;
    }, {});
  }, [intrusivenessLevels, totalContents, isValidatedMember]);
  return currentSettings;
}
var _default = useIntrusiveness;
exports.default = _default;
function useValidation() {
  let memberValidation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return (0, _react.useMemo)(() => {
    const gracePeriod = daysToMs(MEMBER_GRACE_PERIOD);
    return memberValidation >= (0, _siteActions.ts)() - gracePeriod ? true : false;
  }, [memberValidation]);
}
function daysToMs(days) {
  return days * 24 * 60 * 60 * 1000;
}